<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.nol1" :label="labels.nol1" :error-messages="errors.collect('nol1')" data-vv-name="nol1" :data-vv-as="labels.nol1" v-validate="'name|max:2'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.nol1shortDesc" :label="labels.nol1shortDesc" :error-messages="errors.collect('nol1shortDesc')" data-vv-name="nol1shortDesc" :data-vv-as="labels.nol1shortDesc" v-validate="'name|max:10'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.nol1longDesc" :label="labels.nol1longDesc" :error-messages="errors.collect('nol1longDesc')" data-vv-name="nol1longDesc" :data-vv-as="labels.nol1longDesc" v-validate="'name|max:40'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <div>
              <v-btn color="primary" @click.native="doNew()">
                New Nature of Loss 1
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.nol1 }}</td>
                <td>{{ row.item.nol1shortDesc }}</td>
                <td>{{ row.item.nol1longDesc }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item.nol1)" query @query="doQuery(row.item.nol1)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Claim Nature of Loss 1?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Permit Business Class',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pmtNOL1PerBusClsList' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Nature of Loss 1', value: 'nol1' },
        { text: 'Short Description', value: 'nol1shortDesc' },
        { text: 'Long Description', value: 'nol1longDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        nol1: 'Nature of Loss 1',
        nol1shortDesc: 'Short Description',
        nol1longDesc: 'Long Description'
      },
      filters: {
        nol1: undefined,
        nol1shortDesc: undefined,
        nol1longDesc: undefined
      },
      totalItems: 0,
      selectedNol1: undefined,
      deleteNol1: undefined,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInitRelatedLinks() {
      // To resolve the loading issue
      await Promise.all([this.$store.dispatch('pmtNOL1PerBusClsManagementInit')])
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getClmNol1List
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  nol1: datamap.nol1,
                  nol1shortDesc: datamap.nol1shortDesc,
                  nol1longDesc: datamap.nol1longDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.nol1 = null
      this.filters.nol1shortDesc = null
      this.filters.nol1longDesc = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(nol1) {
      this.$router.push({ name: 'clmNOL1Review', params: { nol1: nol1, nol1Mode: 'Review' } })
    },
    doNew() {
      this.$router.push({ name: 'clmNOL1Review', params: { nol1: 'new', nol1Mode: 'New' } })
    },
    doQuery(nol1) {
      this.$router.push({ name: 'clmNOL1Review', params: { nol1: nol1, nol1Mode: 'Query' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedNol1 = data
        this.deleteNol1 = data.nol1
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteClmNol1
      if (apiURI) {
        const expand = this.selectedNol1
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.clmNOL1Param.menu
    }
  },
  mounted() {
    this.doInitRelatedLinks()
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    SideFunctionMenu
  }
}
</script>
